module.exports = __webpack_public_path__ + "assets/img/linux_success_icon.dd4f23eb.svg";